import { Component } from '@angular/core';

interface Testimonial {
  image: string;
  name: string;
  text: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  currentTestimonial = 0;

  testimonials: Testimonial[] = [
    {
      image: 'assets/Home/clientImg.jpg',
      name: 'Christina Becker',
      text: 'Safroo has revolutionized how I plan my trips! Finding trusted tour guides and managing my itinerary was seamless. The local first-hand experiences made my journey unforgettable. Highly recommend!'
    },
    {
      image: 'assets/Home/Male (1).jpg',
      name: 'John Smith',
      text: 'Amazing experience! The local guides were knowledgeable and friendly. Safroo made planning my vacation so much easier. I discovered hidden gems I would never have found on my own.'
    },
    {
      image: 'assets/Home/Female.jpg',
      name: 'Sarah Johnson',
      text: 'Best travel platform ever! Connected with authentic local guides who showed me the real culture. The booking process was smooth and the guides were professional. Will definitely use again!'
    }
  ];

  previousTestimonial(): void {
    this.currentTestimonial = this.currentTestimonial === 0 
      ? this.testimonials.length - 1 
      : this.currentTestimonial - 1;
  }

  nextTestimonial(): void {
    this.currentTestimonial = this.currentTestimonial === this.testimonials.length - 1 
      ? 0 
      : this.currentTestimonial + 1;
  }

  goToTestimonial(index: number): void {
    this.currentTestimonial = index;
  }
}
